const splideReaAutoscrollAll = document.querySelectorAll(".splide-reassurances-auto-scroll");

if (splideReaAutoscrollAll.length) {
  const initializeAutoScroll = (element) => {
    if (!element || element.dataset.autoScrollReady === 'true') {
      return;
    }

    const init = () => {
      if (!window.Splide || !window.splide || !window.splide.Extensions) {
        return;
      }

      new Splide(element, {
        type: "loop",
        arrows: false,
        pagination: false,
        gap: 20,
        autoWidth: true,
        autoScroll: {
          speed: 1,
        },
        mediaQuery: "min",
        breakpoints: {
          1300: {
            destroy: true,
          },
        },
      }).mount(window.splide.Extensions);

      element.dataset.autoScrollReady = 'true';
    };

    if (window.__lfAutoScrollScriptLoaded) {
      init();
      return;
    }

    const script = document.createElement('script');
    script.src = window.LF_AUTO_SCROLL_ASSET;
    script.async = true;
    script.onload = () => {
      window.__lfAutoScrollScriptLoaded = true;
      init();
    };
    document.head.appendChild(script);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        initializeAutoScroll(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '200px 0px',
    threshold: 0.1,
  });

  splideReaAutoscrollAll.forEach((element) => observer.observe(element));
}
